import ActionMenu from 'features/ActionMenu';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import React, { useEffect } from 'react';
import removeHTML from 'shared/utils/removeHTML';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withRouter from 'shared/utils/WithRouter';

export const styles = {
	buttonDiv: {
		textAlign: 'center',
	},
	headline: {
		textAlign: 'center',
	},
	message: {
		padding: '15px 0',
	},
	paper: {
		width: '95%',
		maxWidth: '800px',
		height: 'auto',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '8px',
	},
	paperDiv: {
		padding: '25px',
	},
	toolbar: {
		display: 'flex',
		flexFlow: 'row wrap',
		justifyContent: 'space-between',
		position: 'sticky',
		top: '0',
		backgroundColor: '#FFFFFF',
		marginBottom: '8px',
		zIndex: '2',
		fallbacks: {
			position: '-webkit-sticky',
		},
		headerLogo: {
			height: '100%',
			textAlign: 'center',
		},
		logoImg: {
			objectFit: 'contain',
			height: '100%',
			width: '100%',
		},
	},
};

function ThankYou(props) {
	const { classes, history, settings } = props;

	useEffect(() => {
		if (settings === undefined) {
			props.router.navigate('/now');
		}
		window.scrollTo(0, 0);
	}, []);

	return settings != null ? (
		<div>
			<Toolbar className={classes.toolbar}>
				<ActionMenu />
				<div className={classes.headerLogo} >
					<img alt="logo" id="header-logo-image" className={classes.logoImg} />
				</div>
			</Toolbar>
			<Paper elevation={6} className={classes.paper}>
				<div className={classes.paperDiv}>
					<Typography type="headline" gutterBottom className={classes.headline}>
						{settings.fieldAndFooterSettings.ThankYouPageSettings.ThankYouTitle}
					</Typography>
					<Typography type="body1" component="div" className={classes.message}>
						<div
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: removeHTML(settings.fieldAndFooterSettings.ThankYouPageSettings.ThankYouText),
							}}
						/>
					</Typography>
					<div className={classes.buttonDiv}>
						<Button variant="contained" color="primary" onClick={() => props.router.navigate('/now')}>
							Done
						</Button>
					</div>
				</div>
			</Paper>
		</div>
	) : null;
}

ThankYou.propTypes = {
	classes: PropTypes.shape({}).isRequired,
	settings: PropTypes.shape({
		primary: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
		coApp: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
		comboFields: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.arrayOf(
					PropTypes.shape({ displayText: PropTypes.string, value: PropTypes.string }),
				),
				PropTypes.number,
			]),
		),
		comboFieldsByValue: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.objectOf(
					PropTypes.shape({
						displayOrder: PropTypes.number,
						fieldName: PropTypes.string,
						displayText: PropTypes.string,
						returnValue: PropTypes.string,
						requiresEmploymentData: PropTypes.bool,
					}),
				),
				PropTypes.number,
			]),
		),
		fieldAndFooterSettings: PropTypes.shape({}),
	}),
};

ThankYou.defaultProps = {
	settings: undefined,
};

export default withRouter(withStyles(styles, { name: 'ThankYou' })(ThankYou));
